import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { OpcionesRoutingModule } from './opciones-routing.module';
import { MenuComponent } from './components/menu/menu.component';
import { OpcionesComponent } from './components/opciones/opciones.component';
import { CajaComponent } from './components/caja/caja.component';
import { ProductosComponent } from './components/productos/productos.component';
import { RemesasComponent } from './components/remesas/remesas.component';
import { EgresosComponent } from './components/egresos/egresos.component';
import { PagoComponent } from './components/pago/pago.component';
import { BackdropComponent } from '../shared/backdrop/backdrop.component';
import { ProductosSinBarraComponent } from './components/productos-sin-barra/productos-sin-barra.component';


@NgModule({
  declarations: [
    MenuComponent, 
    OpcionesComponent, 
    CajaComponent, 
    ProductosComponent, 
    RemesasComponent, 
    EgresosComponent, 
    PagoComponent,
    BackdropComponent,
    ProductosSinBarraComponent
  ],
  imports: [
    CommonModule,
    OpcionesRoutingModule,
    ReactiveFormsModule
  ],
  exports: [ OpcionesComponent]
})
export class OpcionesModule { }
